import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLayoutService {
  public showFooter$ = new BehaviorSubject<boolean>(null);
}
